import { observer } from 'mobx-react';
import * as React from 'react';
import ModalReactions from '../../../../Modal/ModalReactions';
import ModalStore from '../../../../Modal/Store';
import ToggleButton from '../../../../ToggleButton';
import LearningCollectionEditStore from '../../Edit/Store';
import BrowseAllWarningModal from './BrowseAllWarningModal';

interface Props {
  store: LearningCollectionEditStore;
  warnUser: () => boolean;
}

class BrowseAllToggle extends React.Component<Props> {
  modalStore: ModalStore = new ModalStore();

  handleToggle = () => {
    const { store, warnUser } = this.props;
    warnUser() ? this.modalStore.open() : store.setBrowseAll(!store.browseAll);
  };

  render() {
    const { store } = this.props;

    return (
      <>
        <ToggleButton
          value={store.browseAll}
          handleOnClick={this.handleToggle}
          ariaLabel="Browse all collections"
        />
        <BrowseAllWarningModal modalStore={this.modalStore} store={store} />
        <ModalReactions store={this.modalStore} />
      </>
    );
  }
}

export default observer(BrowseAllToggle);
